export const MIN_GAIN = 0.0001;
export const MASTER_GAIN = 0.78;
export const MAX_ACTIVE_VOICES = 36;
export const DEFAULT_ATTACK = 0.006;
export const DEFAULT_DECAY = 0.16;
export const DEFAULT_SUSTAIN = 0.32;
export const DEFAULT_RELEASE = 0.42;
export const PERCUSSION_RELEASE = 0.18;

export interface EnvelopeSpec {
  attack: number;
  decay: number;
  sustain: number;
  release: number;
  peakGain: number;
}

export interface AudioVoice {
  id: string;
  noteName?: string;
  output: AudioNode;
  gain: GainNode;
  sources: AudioScheduledSourceNode[];
  cleanupNodes: AudioNode[];
  stop: (when?: number) => void;
  disconnect?: () => void;
  debug?: Record<string, unknown>;
}
